import { Event } from '../../../../base/common/event.js';
class ConstLazyPromise {
    constructor(_value) {
        this._value = _value;
        this.onHasValueDidChange = Event.None;
    }
    request() {
        return Promise.resolve(this._value);
    }
    get value() {
        return this._value;
    }
}
export { ConstLazyPromise };
